export default __webpack_public_path__ + "static/ico-ville-1-148c60984fe4956a89fc5a1a39535ade.svg";